export default __webpack_public_path__ + "static/media/tuffHammerPics11.b037436a.jpeg";